import {Injectable} from '@angular/core';
import {map, Observable, take} from 'rxjs';
import {Backend, SingleResponse} from '@generated-backend-types';
import {ApiService} from './api.service';
import AppVersion = Backend.App.Resources.AppVersion;

@Injectable({providedIn: 'root'})
export class AppVersionService extends ApiService {
  private readonly endpoint = '/version';

  public getVersion(): Observable<AppVersion> {
    return this.http.get<SingleResponse<AppVersion>>(this.endpoint)
      .pipe(take(1), map(value => value.data));
  }
}
